
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SwipeableViews from 'react-swipeable-views'
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  MobileStepper,
  Button,
  Stack
} from '@mui/material'
import {
  School as SchoolIcon,
  PhoneOutlined as PhoneOutlinedIcon,
  OtherHousesOutlined as OtherHousesOutlinedIcon,
  MailOutlined as MailOutlinedIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight
} from '@mui/icons-material'
import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PageCoverImg from "../GeneralComponents/PageCoverImg";
import { Pagination } from "@mui/material";

import Grid from "@mui/material/Grid2";

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import {toSnakeCase} from "../utils/general_utils";
import { ROL_MINEDUC_ADMIN, ROL_REP_EES, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_CON_MINEDUC, ROL_OP_ADMIN, ROL_OP_INS, ROL_ADMIN} from "../../Constants/Constants";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  borderRadius: '20px',
  boxShadow: 'none',
  padding: '0',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#FFFFFF',
  }),
}));
export default function EesCarousel({ includeRol, eesList = [] }) {
  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = eesList.length
  const current = eesList[activeStep] || {}
  const navigate = useNavigate();  



  const [avatarSrc, setAvatarSrc] = useState("/assets/operadores/default.png");
  const handleNext = () => setActiveStep((prev) => (prev + 1) % maxSteps)
  const handleBack = () => setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps)

    const defaultAvatar = "/assets/operadores/default.png";
  const handleError = (e) => {
    if (e.target.src !== defaultAvatar) {
      setAvatarSrc(defaultAvatar);
    }
  };

  /*useEffect(() => {
    const fetchData = async () => {
      if (includeRol([ROL_REP_EES]) && !eesData) {
        axios
          .getEesByRut(userSesion.rut)
          .then((response) => {
            setAvatarSrc(`/assets/operadores/${response.data.id_operador}.png`)
            setEesData(response.data);
          })
          .catch((error) => {
          });
      }
    };
    fetchData();
  }, []);*/

  return (
    
    eesList && eesList.length > 0 && (
      <Grid container spacing={2}>
        <Grid size={8}>
        <Box sx={{display: "flex", height: '100%'}}>
      
       <Button test_id={toSnakeCase("handleBack")} size="small" onClick={handleBack} disabled={maxSteps <= 1} sx={{p: 2, m:0, color: "black", minWidth: 0}}>
                <KeyboardArrowLeft /> 
              </Button>
       
          <Item sx={{ height: '100%', maxWidth: 'calc(100% - 52px)'}}>
          <SwipeableViews
      index={activeStep}
      onChangeIndex={setActiveStep}
      enableMouseEvents
      style={{ height: '100%' }}
      containerStyle={{ height: '100%' }}
      slideStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {eesList.map((eesData) => (
        <Box
          key={eesData.rbd}
          sx={{
            width: '100%',
            px: 2,  maxWidth: 'calc(100% - 48px)'

          }}
        ><Box >
        <Typography variant="h3" align="center">{eesData.nombre_colegio}</Typography>
        <Typography variant="h6" align="center" sx={{ fontFamily: "Roboto", fontWeight: "500" }}>
          RBD: <b>{eesData.rbd}</b>
        </Typography>
        <Divider sx={{ margin: "1rem 0", borderColor: "#F3F3F3" }} />

        {/* Grid con datos del establecimiento */}
        <Grid container>
          <Grid size={6}>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              <ListItem disablePadding>
                <ListItemAvatar>
                  <Avatar sx={{ color: "#111", backgroundColor: "transparent" }}>
                    <SchoolIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="h5">Sostenedor</Typography>}
                  secondary={<Typography variant="body2">{eesData.sostenedor || "Desconocido"}</Typography>}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid size={6}>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              <ListItem disablePadding>
                <ListItemAvatar>
                  <Avatar sx={{ color: "#111", backgroundColor: "transparent" }}>
                    <PhoneOutlinedIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="h5">Teléfono</Typography>}
                  secondary={<Typography variant="body2">{eesData.telefono || "Desconocido"}</Typography>}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid size={6}>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              <ListItem disablePadding>
                <ListItemAvatar>
                  <Avatar sx={{ color: "#111", backgroundColor: "transparent" }}>
                    <OtherHousesOutlinedIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="h5">Dirección</Typography>}
                  secondary={<Typography variant="body2">{eesData.direccion || "Desconocido"}</Typography>}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid size={6}>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              <ListItem disablePadding>
                <ListItemAvatar>
                  <Avatar sx={{ color: "#111", backgroundColor: "transparent" }}>
                    <MailOutlinedIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="h5">E-mail</Typography>}
                  secondary={<Typography variant="body2">{eesData.email || "Desconocido"}</Typography>}
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>

        <Grid container sx={{ paddingTop: 2 }}>
          <Grid size={2}></Grid>
          <Grid size={8}>
            <PageButtonBlack onClick={() => navigate("/establecimiento_modificar/"+eesData.rbd)} width="100%" pad="10px 18px">
              Editar datos del establecimiento
            </PageButtonBlack>
          </Grid>
          <Grid size={2}></Grid>
        </Grid>
      </Box>
    </Box>

            ))}
          </SwipeableViews>

          

    </Item>
            <Button test_id={toSnakeCase("handleNext")} size="small" onClick={handleNext} disabled={maxSteps <= 1} sx={{p: 2, m:0, color: "black", minWidth: 0}}>
                <KeyboardArrowRight />
              </Button>
    </Box>
        </Grid>

        <Grid size={4}>
          <Stack spacing={2}>
            <Item sx={{ heigth: '50%' }}>
              <PageBgBlock pad="30px 0 50px" sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="h5" align="center">Operador</Typography>
                <Divider sx={{ margin: '1.5rem 0', borderColor: '#F3F3F3' }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                  <Avatar
                    alt="operador_logo"
                    src={avatarSrc}
                    onError={handleError}
                    sx={{ width: '3rem', height: '3rem', marginBottom: 2, '& img': { objectFit: 'contain' } }}
                  />
                  <Typography variant="h4" align="center" sx={{ fontFamily: 'Roboto', marginBottom: '-1rem' }}>
                    {current.nombre_operador || 'Desconocido'}
                  </Typography>
                </Box>
              </PageBgBlock>
            </Item>
            <Item sx={{ heigth: '50%', minHeigth: '400px' }}>
              <PageBgBlock pad="30px 0 50px" sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="h5" align="center">Tecnología</Typography>
                <Divider sx={{ margin: '1.5rem 0', borderColor: '#F3F3F3' }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                  <Typography variant="h3" align="center" sx={{ fontFamily: 'Roboto' }}>
                    {current.tecnologia || 'Desconocido'}
                  </Typography>
                </Box>
              </PageBgBlock>
            </Item>
          </Stack>
        </Grid>

       {eesList.length > 1 && (<Grid
  size={8}
  sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}
>
  <MobileStepper
    variant="dots"
    steps={maxSteps}
    position="static"
    activeStep={activeStep}
    sx={{
      backgroundColor: 'transparent',
      p: 0,
      // apuntamos a los dots inactivos...
      '& .MuiMobileStepper-dot': {
        backgroundColor: 'grey',
      },
      // ...y al dot activo
      '& .MuiMobileStepper-dotActive': {
        backgroundColor: 'black',
      },
    }}
  />
</Grid>)}
      </Grid>
    )
  )
}
